import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "h-full flex flex-col justify-between mt-5 gap-3 pb-5 mb-10" }
const _hoisted_2 = { class: "flex gap-2 items-center pb-1 border-b border-secondary" }
const _hoisted_3 = { class: "py-2 text-3xl font-bold text-gray-700" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex flex-col gap-10 mt-10 relative" }
const _hoisted_6 = { class: "w-full md:w-1/2" }
const _hoisted_7 = { class: "flex items-center mt-3" }
const _hoisted_8 = ["max"]
const _hoisted_9 = { class: "flex flex-col gap-3 mt-5" }
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = { class: "mt-auto" }

import { useFishReconciliation } from "@/composables/tasks/fish-reconciliation/useFishReconciliation";
import { onMounted, ref, watch, computed } from "vue";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupView',
  setup(__props) {

const { activeTank, activeGroup, navigateToTankView, updateGroupProgressData } = useFishReconciliation();

const quantity = ref(0);
const comment = ref("");

const totalFishCount = computed(() =>
    activeGroup.value?.amountInTank || activeGroup.value?.count || 0
);

const totalEuthanized = computed(() => {
    if (!activeGroup.value?.progressData) return 0;

    if (Array.isArray(activeGroup.value.progressData)) {
        return activeGroup.value.progressData.reduce(
            (acc, item) => acc + (item.quantity || 0), 0
        );
    } else if (typeof activeGroup.value.progressData === 'object') {
        return activeGroup.value.progressData.quantity || 0;
    }

    return 0;
});

const euthanizationRate = computed(() => {
    if (totalFishCount.value === 0) return "0.00";
    const rate = (totalEuthanized.value / totalFishCount.value) * 100;
    return rate.toFixed(2);
});

const increaseQuantity = () => {
    if (quantity.value < totalFishCount.value) quantity.value++;
};

const decreaseQuantity = () => {
    if (quantity.value > 0) quantity.value--;
};

onMounted(() => {
    if (activeGroup.value?.progressData) {
        const progressData = activeGroup.value.progressData;
        if (typeof progressData === 'object') {
            quantity.value = progressData.quantity || 0;
            comment.value = progressData.comment || "";
        }
    }
});

watch(() => activeGroup.value?.progressData, (newProgressData) => {
    if (newProgressData) {
        quantity.value = newProgressData.quantity || 0;
        comment.value = newProgressData.comment || "";
    }
});

const handleSave = () => {
    const data = {
        quantity: quantity.value,
        comment: comment.value || undefined
    };

    updateGroupProgressData(data);

    if (activeTank.value) {
        navigateToTankView(activeTank.value.key);
    }
};

const handleBack = () => {
    if (activeTank.value) {
        navigateToTankView(activeTank.value.key);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(activeTank)?.label + " - " + _unref(activeGroup)?.name), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeGroup)?.tags, (flag) => {
            return (_openBlock(), _createElementBlock("span", {
              key: flag.title,
              class: "inline-flex mr-2 text-white text-xs p-1 rounded-md font-bold",
              style: _normalizeStyle({ backgroundColor: flag.backgroundColor })
            }, _toDisplayString(flag.title), 5))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-gray-700 text-xl font-bold" }, "Fish euthanized:", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "px-4 py-2 border border-primary font-bold bg-primary text-white",
              onClick: decreaseQuantity
            }, " - "),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quantity).value = $event)),
              min: "0",
              max: totalFishCount.value,
              class: "appearance-none w-full border border-primary px-4 py-2 text-center"
            }, null, 8, _hoisted_8), [
              [
                _vModelText,
                quantity.value,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("button", {
              class: "px-4 py-2 border border-primary font-bold bg-primary text-white",
              onClick: increaseQuantity
            }, " + ")
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("strong", null, [
              _cache[2] || (_cache[2] = _createTextVNode(" Fish in tank: ")),
              _createElementVNode("span", _hoisted_10, _toDisplayString(totalFishCount.value), 1)
            ]),
            _createElementVNode("strong", null, [
              _cache[3] || (_cache[3] = _createTextVNode(" Euthanization rate: ")),
              _createElementVNode("span", _hoisted_11, _toDisplayString(euthanizationRate.value) + "%", 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-gray-700 text-xl font-bold" }, " Leave a comment (optional): ", -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event)),
            class: "w-full mt-5 p-2 border border-secondary",
            rows: "6"
          }, null, 512), [
            [_vModelText, comment.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(FooterActions, null, {
        start: _withCtx(() => [
          _createElementVNode("button", {
            onClick: handleBack,
            class: "w-full"
          }, " Back ")
        ]),
        end: _withCtx(() => [
          _createElementVNode("button", {
            onClick: handleSave,
            class: "w-full"
          }, " Save ")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})